import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  strict: debug,

  state: {
    modalAttr: {
      isModalOpen: false,
      modalVideo: null,
      poster: null,
      vimeoId: null,
    },
   
    heroContent: {
      title: "VECTORWORKS 2023",
      tagline: "SUPERCHARGE YOUR WORKFLOW",
      cta: "WATCH THE VIDEO",
      announcementBanner: {
        copy:
          "SERVICE SELECT & SUBSCRIPTION CUSTOMERS CAN ACCESS THE LATEST RELEASE TODAY.",
        link: "https://www.vectorworks.com/",
        linkText: "DOWNLOAD NOW..",
      },
      image:
        "https://res.cloudinary.com/vectorworks-mktg/image/upload/f_auto/q_auto/w_1500/Rodrigo_tests_/launch_2023/vttgm82u2wzq618kdwc5.webp",
        
    },
    utilityNav: {
      title: "WHAT'S NEW",
      buyNowLabel: "BUY NOW",
      buyNowLink: "https://www.vectorworks.com/",
      freeTrialLabel: "FREE TRIAL",
      freeTrialLink: "https://www.vectorworks.com/",
      links: [
        {
          label: "USER EXPERIENCE",
          anchor: "ux",
        },
        {
          label: "BIM WORKFLOWS",
          anchor: "bimWorkflows",
        },
        {
          label: "BIM FOR LANDSCAPE",
          anchor: "bimforlandscape",
        },
        {
          label: "ENTERTAINMENT",
          anchor: "entertainment",
        },
        {
          label: "INTEROPERABILITY",
          anchor: "interoperability",
        },
      ],
    },
    sections: [
      {
        "id": "ux",
        "background": "light",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "USER EXPERIENCE",
              "copy": "You need design-centered software that does the heavy lifting without pulling you out of your creative flow. That’s why in Vectorworks 2023, you’ll find everyday performance improvements that will speed up your processes and leave you more time to design."
            }
          },
          {
            "blockType": "SlideShow",
            "blockContent": {
              "description": {
                "title": "NEW OFFSET EDGE TOOL",
                "copy": "The new Offset Edge tool lets you offset edges and edge loops from planar and non-planar faces. Offset edges will also include the automatic Push/Pull mode and the support for non-planar faces of 3D objects, giving you more flexibility in your creative process and reducing the steps it takes to model unique 3D solid objects.",
                "products": ["fundamentals", "architect", "landmark", "spotlight"]
              },
              "slides": [
                {
                  "id": "video1",
                  "title": "ARCHITECT",
  
                  "description": "You'll be able to bring your ideas to life faster than ever before — no matter if you're designing a ceiling detail, a light fixture, or even when exploring conceptual building forms.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/f_auto/Rodrigo_tests_/launch_2023/f4oxu8ftd4pnmeizub5g.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1659361337/pages/2023/videos/vwx23-012-offset-edge-push-pull-arch-220723"
                },
  
                {
                  "id": "video2",
                  "title": "LANDMARK",
  
                  "description": "Spend less time modeling features and create your best work with the most flexibility to create sculptures, site furniture, structures, or any other custom objects.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/f_auto/Rodrigo_tests_/launch_2023/f4oxu8ftd4pnmeizub5g.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1660248174/pages/2023/videos/vwx23-013-offset-edge-push-pull-land_220803"
                },
                {
                  "id": "video3",
                  "title": "SPOTLIGHT",
                  "description": "Creating one-of-a-kind stages, sets, and environments is now a breeze. Easily explore scenic elements, props, and backdrops that evoke key aspects of a setting or mood.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/q_auto/f_auto/Rodrigo_tests_/launch_2023/dnp1wduwsgurf0b1utom.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks-mktg/video/upload/v1654628153/Rodrigo_tests_/launch_2023/rvrfij0m2s1czl8e0ogt"
                }
              ]
            }
          },
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "HOME SCREEN",
              "copy": "Getting help with Vectorworks is easier than ever with the new Home Screen — you’ll find a single source for training, learning, product messaging, and growth opportunities. It’s designed to help new designers get started and provide resources to more seasoned designers looking to improve their skills or learn something new.",
              "linkLabel": " LEARN MORE",
              "link": "https://www.vectorworks.com/",
              "products": ["fundamentals", "architect", "landmark", "spotlight"],
              "video": {
                "url": "https://res.cloudinary.com/vectorworks/video/upload/v1660248173/pages/2023/videos/vwx23-015-home-screen-220803",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          },
          {
            "blockType": "SlideShow",
            "blockContent": {
              "description": {
                "title": "NEW SHADED RENDERING OPTIONS",
                "copy": "The Shaded Render Mode supports more light objects, glow textures, environment lighting, and reflections meaning you'll get a better understanding of your project while designing and ensure better quality rendering output.",
  
                "products": ["fundamentals", "architect", "landmark", "spotlight"]
              },
              "slides": [
                {
                  "id": "video1",
                  "title": "ARCHITECT",
  
                  "description": "You can visualize your projects with more realism while working on your design. This will give you direct feedback on how lights and materials interact, making it easier to make informed design decisions.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/f_auto/Rodrigo_tests_/launch_2023/f4oxu8ftd4pnmeizub5g.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1659361338/pages/2023/videos/vwx23-009-shaded-rendering-arch-220719"
                },
  
                {
                  "id": "video2",
                  "title": "LANDMARK",
  
                  "description": "Your nightscape renders are now supported with more light objects and surface textures, which will appear to emit light.  Also, environmental lighting and reflections are now included to give you the realistic spaces you envisioned.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/f_auto/Rodrigo_tests_/launch_2023/f4oxu8ftd4pnmeizub5g.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1659361987/pages/2023/videos/vwx23-010-shaded-rendering-land_220728"
                },
                {
                  "id": "video3",
                  "title": "SPOTLIGHT",
                  "description": "We removed the eight-light limit and now offer more rendering support for textures, textures, gobos, and haze. These features allow you to quickly create and share your design concepts and better understand your scene in shaded mode before the final render to ensure better quality rendering.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/q_auto/f_auto/Rodrigo_tests_/launch_2023/dnp1wduwsgurf0b1utom.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1660248157/pages/2023/videos/vwx23-009-shaded-rendering-ent-220804"
                }
              ]
            }
          },
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "FASTER GENERATION OF SECTION VIEWPORTS",
              "copy": "Streamline your documentation workflow with improvements to Section Viewports. Calculations and processing are moved to the background and take advantage of the Vectorworks Graphics Module. You'll see viewport updates that are up to six times faster and be able to continue working on other tasks at the same time.",
              "products": ["architect", "landmark", "spotlight"],
              "video": {
                "url": "https://res.cloudinary.com/vectorworks-mktg/video/upload/v1655840086/Rodrigo_tests_/acw6tpaucoqsgt89wltx",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          }
        ]
      },
      {
        "id": "baner1",
        "background": "darkest",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "EXCLUSIVE Overview of Everything New in Vectorworks 2023",
              "copy": "Vectorworks Service Select and subscription members can join exclusive, industry-specific What’s New sessions followed by a Q&A.",
              "cta": {
                "isLink": true,
                "label": "REGISTER NOW",
                "url": "https://digg.com/"
              }
            }
          }
        ]
      },
      {
        "id": "bimWorkflows",
        "background": "dark",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "BIM WORKFLOWS",
              "copy": "Vectorworks 2023 brings big updates that will accelerate your BIM workflows without getting bogged down by technology. You’ll find core architectural objects have been re-engineered and modernized, with a better use of data and resources for more precise BIM models and documentation."
            }
          },
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "DIRECT MODELING FOR DOORS AND WINDOWS",
              "copy": "Gone are the days of tediously defining the parameters of these building objects. With direct modeling and editing for Doors and Windows, you can now create and edit doors and windows by simply drawing a rectangle on the face of the wall in 3D or a line spanning the opening in 2D. And you can easily edit doors and windows using the same process as the familiar reshape tool.",
              "products": ["architect", "landmark"],
              "video": {
                "url": "https://res.cloudinary.com/vectorworks/video/upload/v1659361992/pages/2023/videos/vwx23-001-direct-modeling-doors-windows_220730",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          },
          {
            "blockType": "AppImageToSide",
            "blockContent": {
              "title": "FOLDING DOOR AND WINDOW CONFIGURATIONS",
              "copy": "The new folding door and window configurations can now accommodate a custom number of leaves and sashes. These additions will save you time and help you quickly create and manage common multiple folding door and window configurations without needing to custom model them yourself.",
              "products": ["architect"],
              "video": {
                "url": "https://res.cloudinary.com/vectorworks/video/upload/v1659361998/pages/2023/videos/vwx23-002-door-window-configurations_220730",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          },
          {
            "blockType": "FullBleedVideo",
            "blockContent": {
              "title": "GRAPHIC LEGENDS",
              "copy": "Save time and reduce errors with the new Graphic Legends tool. You'll find a smart tool that completely removes the manual process of creating graphic legends. It automatically coordinates with the resources you've used, giving you an easy editing and customization process to ensure the accuracy of legends and drawing keys for documentation.",
              "products": ["architect", "landmark", "spotlight"],
              "gradient": true,
              "video": {
                "url": "https://res.cloudinary.com/vectorworks/video/upload/v1659361343/pages/2023/videos/vwx23-004-graphic-legends-220721",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          },
          {
            "blockType": "AppTwoCols",
            "blockContent": [
              {
                "title": "IMPROVED BIM ISSUE MANAGEMENT",
                "copy": "Experience better, faster, and more accurate BIM collaboration using BIM Collaboration Format (BCF) files. The BCF Manager is now a web palette that can be kept open so you can seamlessly and efficiently manage model changes with cloud-based collaboration tools like BIMCollab, BIMSync, and more.",
                "products": ["architect", "landmark"],
                "image": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1611674794/samples/bike.jpg"
              },
              {
                "title": "ELEVATION BENCHMARK",
                "copy": "See better change management of BIM models and faster drawing creation with improvements to elevation benchmarks. In the latest version of Vectorworks, elevation benchmarks will now connect to Story Levels and are automatically created in Section and Elevation viewports. The new elevation benchmarks are symbol-based, making graphics more customizable to fit your needs.",
                "products": ["architect", "landmark"],
                "image": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1643688097/strapi/small_dog_3fa426b744.webp"
              }
            ]
          },
          {
            "blockType": "AppImageToSide",
            "blockContent": {
              "title": "STRUCTURAL MEMBER STYLES",
              "copy": "Improvements to Structural Member objects bring the ability to \"style\" a structural member so its parameters can be saved, edited, and reused by you or your teammates. Gain better control of your modeling workflow when exploring design options or when a change is required.",
              "products": ["architect"],
              "image": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1656013191/Rodrigo_tests_/launch_2023/bwj3kf2sggqpdu5v4d5x.png"
            }
          },
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "WALL IMPROVEMENTS",
              "copy": "With improvements to Wall tools, you'll gain efficiency with a more intuitive workflow and more accurate graphic output. These improvements include combining the Wall and Round Wall tools, more consistent ways to create and edit walls, and better control for texture mapping and inserting objects into walls.",
              "products": ["architect"],
              "video": {
                "url": "https://res.cloudinary.com/vectorworks/video/upload/v1659361999/pages/2023/videos/vwx23-003-wall-improvements_220730",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          },
          {
            "blockType": "AppImageToSide",
            "blockContent": {
              "title": "POWERFUL DATA REPORTING ADDITIONS",
              "copy": "Easily create detailed reports and quantity takeoffs for building objects using a new set of functions and function parameters. With these improvements, you'll be able to produce highly accurate reports for walls, slabs, roofs, and railing/fence objects and their defining components.",
              "products": ["architect", "landmark"],
              "image": "https://res.cloudinary.com/vectorworks/image/upload/v1660248177/pages/2023/illustrations/powerful-data-reporting-additions.jpg",
             
            }
          }
        ]
      },
      {
        "id": "baner2",
        "background": "darkest",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "Exclusive Overview of Everything New in Vectorworks 2023",
              "copy": "Vectorworks Service Select and subscription members can join exclusive, industry-specific What’s New sessions followed by a Q&A.",
              "cta": {
                "isLink": true,
                "label": "Register Now",
                "url": "https://digg.com/"
              }
            }
          }
        ]
      },
      {
        "id": "bimforlandscape",
        "background": "light",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "BIM FOR LANDSCAPE",
              "copy": "Vectorworks is paving the way to make adopting BIM into your workflow easy. With improved visual and organizational capabilities and new tools for site grading and hedgerows, you can go further with your creativity in Vectorworks 2023."
            }
          },
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "SITE GRADING IMPROVEMENTS",
              "copy": "Spend less time on grading plans and terrain modeling and have more time to design. Improvements to Vectorworks’ site grading capabilities with new Site Modifiers modes like \"Aligned,\" \"Pathway Path,\" and \"Boundary Path\" will allow site designers to create more complex grading projects with new ways to account for proper drainage, vehicular/pedestrian use, and better control via contour drawing and editing. ",
              "products": ["architect", "landmark"],
              "video": {
                "url": "https://res.cloudinary.com/vectorworks-mktg/video/upload/v1655840086/Rodrigo_tests_/acw6tpaucoqsgt89wltx",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          },
          {
            "blockType": "AppImageToSide",
            "blockContent": {
              "title": "NEW GEOREFERENCING SETTINGS AND REFERENCED FILE SUPPORTt",
              "copy": "Vectorworks' GIS and georeferencing integrations make file collaboration simpler by automatically placing referenced files using GIS settings from a master document. New GIS Settings and Coordinates also allow you to note your preferred method of coordinate entry, so you can incorporate georeferencing data more accurately.",
              "products": ["architect", "landmark"],
              "image": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1656013191/Rodrigo_tests_/launch_2023/bwj3kf2sggqpdu5v4d5x.png"
            }
          },
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "LAUBWERK PLANT OBJECTS",
              "copy": "Breathe new (plant) life into your projects with the integration of Laubwerk Plant objects. You’ll have access to a new, extensive library of 3D plant geometry with a wide range of detail levels, seasonal changes, and growth representations — ready for you to integrate into your Plant styles or on their own. Add better 3D plant representation for documentation and collaboration while maintaining manageable file sizes. LEARN MORE",
              "products": ["architect", "landmark"],
              "video": {
                "url": "https://res.cloudinary.com/vectorworks-mktg/video/upload/v1655840086/Rodrigo_tests_/acw6tpaucoqsgt89wltx",
                "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1655840586/Rodrigo_tests_/w5jpxyw8rxhs61znczx5.jpg"
              }
            }
          },
          {
            "blockType": "AppImageToSide",
            "blockContent": {
              "title": "HEDGEROW TOOL AND OBJECT",
              "copy": "With Vectorworks Landmark 2023, you can easily specify and model hedgerows — mixed or single species. Seamlessly apply hedges to the site model surface in both 2D and 3D views, quantify by linear unit, and simultaneously illustrate them at mature spread and height.",
              "products": ["landmark"],
              "image": "https://res.cloudinary.com/vectorworks-mktg/image/upload/v1656013191/Rodrigo_tests_/launch_2023/bwj3kf2sggqpdu5v4d5x.png"
            }
          }
        ]
      },
      {
        "id": "baner3",
        "background": "darkest",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "Exclusive Overview of Everything New in Vectorworks 2023",
              "copy": "Vectorworks Service Select and subscription members can join exclusive, industry-specific What’s New sessions followed by a Q&A.",
              "cta": {
                "isLink": true,
                "label": "Register Now",
                "url": "https://digg.com/"
              }
            }
          }
        ]
      },
      {
        "id": "entertainment",
        "background": "dark",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "ENTERTAINMENT",
              "copy": "We’re continually improving our entertainment products to ensure they’re the tools you can trust. Vectorworks 2023 brings everyday quality and performance improvements to your workflows, reducing the amount of manual work and giving back the time you need to design."
            }
          },
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "CABLE AND POWER PLANNING ENHANCEMENTS",
              "copy": "Experience faster cable configuration and planning with the latest upgrades. The new Property View tab in the Power Planning palette will allow for easier selection and editing of objects in your model. New filter, sort, and edit options in the Property View will also make cable and device management more user-friendly. To top it all off, updates to the cable path now report all associated cables to a Data Tag, making documentation easier.",
              "products": ["spotlight"],
              "image": "https://res.cloudinary.com/vectorworks/image/upload/f_auto/pages/2023/illustrations/cable-and-power-planning-enhancements.jpg"
            }
          },
          {
            "blockType": "AppImageToSide",
            "blockContent": {
              "title": "RIGGING WORKFLOW IMPROVEMENTS",
              "copy": "Rigging design and planning is easier in Vectorworks Spotlight 2023.  Better integration between hoist and bridle objects allows for more consistent and manageable documentation, and two-leg bridle behaviors have been updated for consistency. Also, increased control over the now symbol-based truss cross object will ease a significant portion of your workflow.",
              "products": ["spotlight"],
              "image": "https://res.cloudinary.com/vectorworks/image/upload/v1660248176/pages/2023/illustrations/cable-and-power-planning-enhancements.jpg"
            }
          },
          {
            "blockType": "SlideShow",
            "blockContent": {
              "description": {
                "title": "CONNECTCAD WORKFLOW IMPROVEMENTS",
                "copy": "Significant workflow improvements to ConnectCAD in Vectorworks 2023 include more intuitive class structuring and assignment, the ability to specify device locations in a schematic layout for more automated equipment lists, the ability to add project devices to the database, and more intelligent choice list generation. Each improvement will make it easier to find what you need and quickly generate accurate documentation.",
                "products": ["connectCAD"]
              },
              "slides": [
                {
                  "id": "video1",
                  "title": "CONNECTCAD ADAPTER OBJECT",
  
                  "description": "Find more accurate representation and reporting of your schematic design components with the new ConnectCAD Adapter tool. When the new adapter object is attached to a device socket, it converts the connector types and signal types and matches the socket orientation. Circuits now automatically draw themselves according to the adaptor's direction, decreasing the amount of manual work and ensuring accurate reporting.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/f_auto/Rodrigo_tests_/launch_2023/f4oxu8ftd4pnmeizub5g.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1660248135/pages/2023/videos/vwx23-008-ccad-adapter-220805"
                },
  
                {
                  "id": "video2",
                  "title": "CONNECTCAD CABLE RISER DIAGRAMS",
  
                  "description": "Updates to the ConnectCAD Cable tool are designed to provide a faster and more accurate way to create cable riser diagrams and reports. The new ability to generate cable riser diagrams will allow you to produce documentation familiar to electrical contractors, so you can get faster responses to on-site changes and quickly evaluate costs.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/f_auto/Rodrigo_tests_/launch_2023/f4oxu8ftd4pnmeizub5g.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1660248151/pages/2023/videos/vwx23-007-ccad-cable-riser-220808"
                },
                {
                  "id": "video3",
                  "title": "CONNECTCAD SOCKET EDITING",
                  "description": "ConnectCAD 2023 introduces the new ConnectCAD Socket Editing feature, providing two new and faster ways of addressing socket issues with your devices, saving you significant time when making minor edits.",
                  "poster": "https://res.cloudinary.com/vectorworks-mktg/image/upload/q_auto/f_auto/Rodrigo_tests_/launch_2023/dnp1wduwsgurf0b1utom.jpg",
                  "videoUrl": "https://res.cloudinary.com/vectorworks/video/upload/v1660248151/pages/2023/videos/vwx23-007-ccad-cable-riser-220808"
                }
              ]
            }
          }
        ]
      },
      {
        "id": "baner44",
        "background": "darkest",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "Exclusive Overview of Everything New in Vectorworks 2023",
              "copy": "Vectorworks Service Select and subscription members can join exclusive, industry-specific What’s New sessions followed by a Q&A.",
              "cta": {
                "isLink": true,
                "label": "Register Now",
                "url": "https://digg.com/"
              }
            }
          }
        ]
      },
      {
        "id": "interoperability",
        "background": "light",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "INTEROPERABILITY",
              "copy": "Vectorworks remains the unrivaled choice for BIM collaboration. Now, you’ll have even more ways to work with whoever, whenever — no matter the platform."
            }
          },
          {
            "blockType": "AppTwoCols",
            "blockContent": [
              {
                "title": "IMPROVED COLLABORATION WITH REVIT FILES",
                "copy": "New Revit file import options in Vectorworks 2023 give you more flexibility when collaborating with consultants and clients using Revit. Now, Vectorworks will support the translation of more Revit object types and provide better organization of the imported file data making it easier to design your project within the context of existing information. You can also reference a Revit file directly for a better collaborative workflow.",
                "products": ["architect", "landmark", "spotlight"],
                "image": "https://res.cloudinary.com/vectorworks/image/upload/v1660248178/pages/2023/illustrations/improved-collaboration-with-revit-files.png"
              },
              {
                "title": "IFC IMPORT IMPROVEMENTS",
                "copy": "Experience faster, more reliable results when working with IFC files. Collaborate more effectively with faster imports and the ability to import from more applications. You'll have greater control of imported files with new options to filter objects upon import. You’ll also have access to class, story, and criteria-based mapping for alignment with your Vectorworks file organization.",
                "products": ["architect", "landmark", "spotlight"],
                "image": "https://res.cloudinary.com/vectorworks/image/upload/v1660248177/pages/2023/illustrations/ifc-import-improvements.jpg"
              }
            ]
          }
        ]
      },
      {
        "id": "baner4",
        "background": "darkest",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "PRESS RESOURCES",
              "copy": "Everything you need to cover our latest release — find our press release, videos, images, and product information below.",
              "cta": {
                "isLink": true,
                "label": "LEAN MORE",
                "url": "https://digg.com/"
              }
            }
          }
        ]
      },
      {
        "id": "more",
        "background": "light",
        "blocks": [
          {
            "blockType": "AppSingleColumn",
            "blockContent": {
              "title": "MORE IN VECTORWORKS 2023",
              "features": [
                {
                  "title": "IMPROVED RESOURCE LIBRARIES ORGANIZATION",
                  "description": "Easily find symbols, styled objects, and other resources you need using the newly reorganized content libraries in the Resource Manager. Content library folders have been consolidated and reorganized with more intuitive and industry-specific names, making your search for the perfect resource easier than ever.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": [
                    "fundamentals",
                    "architect",
                    "landmark",
                    "spotlight"
                  ]
                },
                {
                  "title": "ADDITIONAL SITE MODELING COMMANDS IN ARCHITECT",
                  "description": "Shape your project's site more accurately than ever with a full suite of site modeling tools now in Vectorworks Architect. You'll have access to site modeling commands, including pad and contour modifiers, surface sculpting and Create Retaining Wall Site Modifier, and more.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": ["architect"]
                },
                {
                  "title": "CLOUD PRESENTATION IMPROVEMENTS",
                  "description": "Improvements to Cloud Presentations will provide more freedom to create and customize boards and virtual tours in Vectorworks Cloud Services. In virtual tours, you’ll find added compatibility with various file types, such as 3D models, videos, images, PDFs, and the ability to create text and hyperlink-based pins. Put Vectorworks Cloud Services to work to share your design and impress your clients.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": [
                    "fundamentals",
                    "architect",
                    "landmark",
                    "spotlight"
                  ]
                },
                {
                  "title": "SEND TO SURFACE IMPROVEMENTS",
                  "description": "Save time moving objects to surfaces with Send to Surface improvements. You'll be able to send objects to a site model surface or another finished surface, such as a hardscape or landscape area, saving you time in your 3D site modeling process and providing the tools for creating a more accurate model.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": ["architect", "landmark"]
                },
                {
                  "title": "EXPANDED DATA MANAGER CAPABILITIES",
                  "description": "The Data Manager’s capabilities are being expanded to improve its usability. You can now search, filter, and select multiple data sets for editing. A new “copy mapping from” button let’s you copy/paste data mappings from one object to another.  You can also create and manage custom data sets within the Data Manager itself. With these additions, the Data Manager is more predictable and easier to use when creating and managing all types of data.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": ["architect", "landmark", "spotlight"]
                },
                {
                  "title": "DATA TAGS ENHANCEMENTS",
                  "description": "VGain greater efficiency in Vectorworks 2023, with more control of creating and customizing data tags. Intuitively find and change data tag object associations, display varying units per instance as needed, and define a scale for use in sheet layers or in design layers.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": ["architect", "landmark", "spotlight"]
                },
                {
                  "title": "REDSHIFT FOR EVERYONE",
                  "description": "Vectorworks 2023 takes full advantage of Maxon's Redshift Everywhere initiative that puts Redshift render styles within reach of all customers, regardless of the type of hardware you're using. No longer limited to just a computer's GPU, Redshift will now instead utilize your computer's CPU for processing requirements. ",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": [
                    "fundamentals",
                    "architect",
                    "landmark",
                    "spotlight"
                  ]
                },
                {
                  "title": "MARIONETTE OBJECT STYLES",
                  "description": "Easily create and update custom Marionette objects used in your files with Marionette Object Styles. Marionette can now be set as \"styled objects\" so they can be quickly found in the Resource Manager. This makes it easier to use these objects once, and it’s faster to duplicate them and share the styles between files and team members.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": ["architect", "landmark", "spotlight"]
                },
                {
                  "title": "SPOTLIGHT QUALITY IMPROVEMENTS AND ENHANCEMENTS",
                  "description": "Get peace of mind with Vectorworks 2023 and the newest improvements and enhancements to Vectorworks Spotlight. We've worked to address some common workflow issues with lighting devices and worksheet functions. These updates mean easier drawing and more precise designs, leaving you more time to focus on your creative process.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": ["spotlight"]
                },
                {
                  "title": "CUSTOMIZABLE DWG IMPORT/EXPORT OPTIONS",
                  "description": "Exchanging DWG and DXF files is essential to your workflows, and with this new collection of user-friendly import/export improvements, you’ll spend less time cleaning up your imported base files or your exports. You’ll be able to customize which items and layers are exported in your file through the new, simplified export dialog. And when importing, you’ll be able to easily select which layers and objects to include.",
                  "icon": "https://res.cloudinary.com/vectorworks/image/upload/v1642654823/academic_free-software-for-you.jpg",
                  "products": [
                    "fundamentals",
                    "architect",
                    "landmark",
                    "spotlight"
                  ]
                }
              ]
            }
          }
        ]
      }
    ],
    uiCopy: {
    learnMore: "LEARN MORE",
    }
  },

  mutations: {
    UPDATE_MODAL_STATE(state, payload) {
      state.modalAttr.isModalOpen = !state.modalAttr.isModalOpen;
    if (payload != null) {
      const root = document.getElementsByTagName( 'html' )[0] 
      root.classList.toggle('noOverflow') 
      state.modalAttr.modalVideo = payload.url;
      state.modalAttr.poster = payload.poster;
      if (typeof payload.vimeoId !== "undefined") {
        state.modalAttr.vimeoId = payload.vimeoId;
      }
     
    }
    if (state.modalAttr.isModalOpen) {
      const root = document.getElementsByTagName( 'html' )[0] 
      root.classList.add('noOverflow') 
    } else {
      const root = document.getElementsByTagName( 'html' )[0] 
      root.classList.remove('noOverflow') 
      state.modalAttr.modalVideo = null;
      state.modalAttr.poster = null;
      state.modalAttr.vimeoId = null;
    }
  },

    SET_CONTENT(state, content) {
      if(content.heroContent && content.utilityNav && content.sections) {
        state.heroContent = content.heroContent;
        state.utilityNav = content.utilityNav;
        state.sections = content.sections;
        state.uiCopy = content.uiCopy;
      }
    },
  },

  getters: {
    utilityNav(state) {
      return state.utilityNav;
    },

    heroContent(state) {
      return state.heroContent;
    },

    sections(state) {
      return state.sections;
    },
    learnMore(state) {
      return state.uiCopy.learnMore;
    }, 
    registerNow(state) {
      return state.uiCopy.registerNow;
    },
    watchVideo(state) {
      return state.uiCopy.watchVideo;
    },
  },

  actions: {
    toggleModal({ commit }, payload) {
        
      commit("UPDATE_MODAL_STATE", payload);
    },

    setContent({ commit }, content) {

      let oldcontent = content;
      content = JSON.parse(JSON.stringify(content));


      commit("SET_CONTENT", content);
    },
  },
});



// WEBPACK FOOTER //
// ./resources/assets/vuejs/frontend/2023-launch/stores/launch2023_store.js